import React, { useState, useEffect } from 'react';
import { useAuth } from "../../src/Context/AuthContext";

const AdminNav = ({ onNavClick, selectedSection }) => {
    //State Variables
    const [portalSettings, setPortalSettings] = useState(null);
    const [loading, setLoading] = useState(true);
    const { user, loading: authLoading, logout } = useAuth(); 

    //ENV Variables
    const apiURL = import.meta.env.VITE_API;

    useEffect(() => {
        const fetchPortalSettings = async () => {
            try {
                const res = await fetch(`${apiURL}/shared/getPortalSettings`, {
                    method: "GET",
                    credentials: "include",
                });

                if (res.status === 401) {
                    logout();
                    navigate('/login');
                    throw new Error("unauthorized");
                }

                if (res.status === 403) {
                    navigate('/home');
                    throw new Error("forbidden");
                }

                if (!res.ok) {
                    throw new Error("Failed to fetch portal settings");
                }

                const data = await res.json();
                setPortalSettings(data);
            } catch (error) {
                console.error("Error fetching portal settings:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchPortalSettings();
    }, []);

    // Loading state: wait for both auth and settings
    if (loading || authLoading || !portalSettings) return null;

    const psm = portalSettings;

    const navButton = (id, label, condition = true) =>
        condition && (
            <span
                key={id}
                className={`nav-button ${selectedSection === id ? 'active' : ''}`}
                onClick={() => onNavClick(id)}
            >
                {label}
            </span>
        );

    return (
        <div className="nav-buttons-container">
            <div className="nav-buttons d-md-block buttons-wrapper">
                {navButton('policy-search-container', 'Policy Search', psm.hasPolicyPortal)}
                {navButton('agent-search-container', 'Agent Search', psm.hasAgentPortal)}
                {navButton('registered-search-container', 'Registration Attempts')}
                {navButton('login-attempts-container', 'Login Attempts')}
                {navButton('admin-materials-container', 'Materials', psm.hasAgentPortal || psm.hasPolicyPortal)}
                {navButton('email-send-container', 'Registration Emails', psm.hasAgentPortal || psm.hasPolicyPortal)}
                {navButton('manage-admin-container', 'Manage Admins', user?.role === 1 || user?.role === "1")}
            </div>
        </div>
    );
};

export default AdminNav;
